export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10854.b5644565.jpg";